import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { getSafeInternalPath } from "../utils/safeNavigate";
import { syncMaritalStatus } from "../constants/maritalStatus";
import WeChatLoginButton from "../components/WeChatLoginButton";

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get("redirect") || "";

  const [role, setRole] = useState("user"); // user / consultant
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [loading, setLoading] = useState(false);

  // 生成验证码
  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";

    for (let i = 0; i < 4; i++) {
      code += chars[Math.floor(Math.random() * chars.length)];
    }

    setCaptcha(code);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // 登录
  const handleLogin = async () => {
    if (!account || !password) {
      alert("请输入邮箱或手机号和密码");
      return;
    }

    if (captchaInput.toUpperCase() !== captcha) {
      alert("验证码错误");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setLoading(true);

    try {
      const api =
        role === "user"
          ? "/api/login"
          : "/api/consultant/login";

      const res = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          account: account.trim(),
          password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.detail || data.msg || "登录失败");
        generateCaptcha();
        setCaptchaInput("");
        return;
      }

      // 普通用户登录
      if (role === "user") {
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("name", data.name || "");
        syncMaritalStatus(data.marital_status || "");

        const profileCompleted = data.profile_completed === 1;
        const hasQuestionnaire = data.has_questionnaire === 1;

        if (!profileCompleted) {
          navigate("/profile/setup");
        } else if (!hasQuestionnaire) {
          navigate("/questionnaire");
        } else {
          const safeRedirect = getSafeInternalPath(redirectPath);
          if (safeRedirect) {
            navigate(safeRedirect);
          } else {
            navigate("/");
          }
        }
      }

      // 咨询师登录



      else {

  localStorage.setItem("consultant_id", data.consultant_id);

  localStorage.setItem("consultant_name", data.name || "");


    navigate("/consultant/");

}
    } catch (err) {
      console.error(err);
      alert("请求失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col">
      <Header />

      <main className="flex-1 w-full px-4 pt-10 pb-12 sm:pt-14 sm:pb-16 flex justify-center">
        <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md h-fit mt-2 mb-6">
          <h2 className="text-2xl font-bold text-center mb-6">
            {role === "user" ? "用户登录" : "咨询师登录"}
          </h2>

          {role === "user" && (
            <div className="mb-6 space-y-3">
              <WeChatLoginButton
                redirect={getSafeInternalPath(redirectPath) || "/love-map"}
              />
              <div className="flex items-center gap-3 text-xs text-gray-400">
                <span className="flex-1 h-px bg-gray-200" />
                或使用账号密码
                <span className="flex-1 h-px bg-gray-200" />
              </div>
            </div>
          )}

          {/* 身份切换 */}
          <div className="flex bg-gray-100 rounded-xl p-1 mb-6">
            <button
              onClick={() => setRole("user")}
              className={`flex-1 py-2 rounded-lg font-medium transition ${
                role === "user"
                  ? "bg-pink-500 text-white shadow"
                  : "text-gray-600"
              }`}
            >
              用户登录
            </button>

            <button
              onClick={() => setRole("consultant")}
              className={`flex-1 py-2 rounded-lg font-medium transition ${
                role === "consultant"
                  ? "bg-purple-500 text-white shadow"
                  : "text-gray-600"
              }`}
            >
              咨询师登录
            </button>
          </div>

          {/* 邮箱或手机号 */}
          <input
            type="text"
            placeholder="请输入邮箱或手机号"
            value={account}
            onChange={(e) => setAccount(e.target.value)}
            className="w-full border p-3 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-pink-400"
          />

          {/* 密码 */}
          <input
            type="password"
            placeholder="请输入密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border p-3 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-pink-400"
          />

          <div className="text-right mb-4">
            <Link to="/forgot-password" className="text-sm text-pink-600 hover:underline">
              忘记密码？
            </Link>
          </div>

          {/* 验证码 */}
          <div className="flex gap-2 mb-4">
            <input
              type="text"
              placeholder="验证码"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              className="flex-1 border p-3 rounded-lg"
            />

            <div
              onClick={generateCaptcha}
              className="w-24 flex items-center justify-center rounded-lg bg-gray-100 border cursor-pointer font-bold tracking-widest"
            >
              {captcha}
            </div>
          </div>

          {/* 登录按钮 */}
          <button
            onClick={handleLogin}
            disabled={loading}
            className={`w-full py-3 rounded-lg text-white transition ${
              loading
                ? "bg-gray-300"
                : role === "user"
                ? "bg-pink-500 hover:bg-pink-600"
                : "bg-purple-500 hover:bg-purple-600"
            }`}
          >
            {loading ? "登录中..." : "立即登录"}
          </button>

          {/* 注册入口 */}
          <p
            onClick={() =>
              navigate(role === "user" ? "/register" : "/registerConsultants")
            }
            className="text-center text-sm text-gray-500 mt-4 cursor-pointer hover:text-gray-700"
          >
            没有账号？去注册
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}